import React from 'react';
import { ControlPosition, MapControl } from '@vis.gl/react-google-maps';

import type { AutocompleteMode } from './DealerLocatorMap';
import { PlaceAutocompleteClassic } from './PlaceAutocompleteClassic';

type CustomAutocompleteControlProps = {
  controlPosition: ControlPosition;
  selectedAutocompleteMode: AutocompleteMode;
  onPlaceSelect: (place: google.maps.places.PlaceResult | null) => void;
};

export const CustomMapControl = ({
  controlPosition,
  selectedAutocompleteMode,
  onPlaceSelect,
}: CustomAutocompleteControlProps) => {
  return (
    <MapControl position={controlPosition}>
      <div className='autocomplete-control'>
        <PlaceAutocompleteClassic onPlaceSelect={onPlaceSelect} />
      </div>
    </MapControl>
  );
};
